import { motion } from 'framer-motion';
import { useInView } from '../hooks/useInView';

const ServiceZones = () => {
  const [ref, inView] = useInView({ threshold: 0.1 });

  const zones = [
    { name: 'Toulouse', distance: 'Centre-ville', link: '/' },
    { name: 'Colomiers', distance: '12 km', link: '/colomiers' },
    { name: 'Blagnac', distance: '7 km', link: '/blagnac' },
    { name: 'Tournefeuille', distance: '10 km', link: '/tournefeuille' },
    { name: 'Muret', distance: '20 km', link: '/muret' },
    { name: 'Balma', distance: '7 km', link: '/balma' },
    { name: 'Ramonville-Saint-Agne', distance: '5 km', link: '/ramonville' },
    { name: 'Cugnaux', distance: '8 km', link: '/cugnaux' },
    { name: 'L\'Union', distance: '8 km', link: '/' },
    { name: 'Saint-Orens-de-Gameville', distance: '10 km', link: '/' },
    { name: 'Plaisance-du-Touch', distance: '12 km', link: '/' },
    { name: 'Portet-sur-Garonne', distance: '15 km', link: '/' },
  ];

  return (
    <section id="zones" ref={ref} className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          animate={inView ? { opacity: 1, y: 0 } : {}}
          transition={{ duration: 0.6 }}
          className="text-center mb-16"
        >
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
            Nos <strong className="text-teal-600">Zones</strong> d'Intervention
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Nous intervenons dans <strong>toute la Haute-Garonne (31)</strong> pour vos réparations de fenêtres, vitrerie et menuiserie
          </p>
        </motion.div>

        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-6 mb-12">
          {zones.map((zone, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, scale: 0.9 }}
              animate={inView ? { opacity: 1, scale: 1 } : {}}
              transition={{ duration: 0.4, delay: index * 0.05 }}
              className="bg-gradient-to-br from-teal-50 to-orange-50 rounded-lg p-6 text-center hover:shadow-lg transition-all cursor-pointer group"
            >
              <div className="w-12 h-12 bg-white rounded-full flex items-center justify-center mx-auto mb-3 group-hover:bg-teal-500 transition-colors">
                <i className={`ri-community-line text-2xl text-teal-600 group-hover:text-white transition-colors`}></i>
              </div>
              <h3 className="font-semibold text-gray-900">{zone.name}</h3>
            </motion.div>
          ))}
        </div>

        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={inView ? { opacity: 1, y: 0 } : {}}
          transition={{ duration: 0.6, delay: 0.8 }}
          className="bg-gradient-to-r from-teal-500 to-orange-500 rounded-lg p-8 text-center text-white"
        >
          <h3 className="text-2xl font-bold mb-4">
            Couverture Complète de la Haute-Garonne
          </h3>
          <p className="text-lg mb-6 opacity-90">
            Nous intervenons dans <strong>toutes les villes et communes de la Haute-Garonne (31)</strong>. Que vous soyez à Toulouse, dans l'agglomération ou dans une commune rurale, notre équipe se déplace rapidement pour tous vos besoins en réparation de fenêtres, vitrerie et menuiserie.
          </p>
          <div className="flex flex-wrap justify-center gap-4 mb-6">
            <div className="bg-white/20 backdrop-blur-sm rounded-full px-6 py-2">
              <i className="ri-map-pin-line mr-2"></i>
              <strong>589 communes</strong> desservies
            </div>
            <div className="bg-white/20 backdrop-blur-sm rounded-full px-6 py-2">
              <i className="ri-car-line mr-2"></i>
              Intervention <strong>sous 24h</strong>
            </div>
            <div className="bg-white/20 backdrop-blur-sm rounded-full px-6 py-2">
              <i className="ri-time-line mr-2"></i>
              Urgences <strong>24h/24</strong>
            </div>
          </div>
          <a
            href="tel:0554542545"
            className="inline-block bg-white text-teal-600 px-8 py-4 rounded-full font-semibold text-lg hover:bg-gray-50 transition-all shadow-lg hover:scale-105 whitespace-nowrap cursor-pointer"
          >
            <i className="ri-phone-line mr-2"></i>
            Appelez-nous : 05 54 54 25 45
          </a>
        </motion.div>
      </div>
    </section>
  );
};

export default ServiceZones;
